import { PREFERENCECENTER } from "../../constants/action-types";
const initialState = {
  preferenceCenterDataTable: [],
  audienceByFieldData: null,
};

const PreferenceCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case PREFERENCECENTER.GET_TABLE_DATA: {
      return Object.assign({}, state, {
        preferenceCenterDataTable: action.payload,
      });
    }

    case PREFERENCECENTER.GET_AUDIENCE_BY_FIELD_DATA: {
      return Object.assign({}, state, {
        audienceByFieldData: action.payload,
      });
    }

    default:
      return state;
  }
};

export default PreferenceCenterReducer;
